export default __webpack_public_path__ + "static/media/drag-dots.4d07c66e.svg";